
import {Component, Mixins, Prop} from "vue-property-decorator";
import {BankaHacziParamsBankaRow} from "@/plugins/uyap-plugin/uyap/BankaHacziParams";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import {BankaSorguSatiri, sorguBankalariniBul} from "@/plugins/uyap-plugin/utils/bankaEslestirme";

@Component({
  components: {}
})

export default class HacizTalepBankaPicker extends Mixins(SimpleInputMixin) {
  @Prop() showUyapIcon!: string | boolean;
  @Prop() tooltip!: string;
  @Prop() maxDisplay!: number;
  @Prop() mevcutBankalar?: Array<BankaSorguSatiri>;
  @Prop() label!: string;
  @Prop() info!: string;

  items: Array<BankaHacziParamsBankaRow> = [];

  get isShowUyapIcon() {
    return this.showUyapIcon || this.showUyapIcon === "";
  }

  created() {
    this.load();
  }

  tumunuSec() {
    this.$nextTick(() => {
      if (this.localValue?.length == this.items.length) {
        this.localValue = []
      } else {
        this.localValue = [...this.items];
      }
      this.input();
    })
  }

  get icon() {
    if (this.localValue?.length == this.items.length)
      return 'mdi-close-box';
    if (this.localValue?.length > 0)
      return 'mdi-minus-box';
    return 'mdi-checkbox-blank-outline';
  }

  async load() {
    let bankalar = (await this.$uyap.BankaHacziParams().run({})).bankalar.sort((a, b) => (a.ilgili.localeCompare(b.ilgili)));
    if (this.mevcutBankalar && this.mevcutBankalar.length > 0) {
      // Listede bulunamayan banka varsa kullanıcı onu elle seçebilsin diye tüm liste gösterilir. (DEV-3513)
      const {eslesen, eslesmeyenVar} = sorguBankalariniBul(bankalar, this.mevcutBankalar);
      this.items = eslesmeyenVar || eslesen.length == 0 ? bankalar : eslesen;
    } else
      this.items = bankalar;
  }
}
